export const OFFER_CARD_HEIGHT = 120;
export const OFFER_CARD_WIDTH = OFFER_CARD_HEIGHT;
